export default {
  PDR1: 1,
  PDR2: 2,
  PDR3: 3,
  SunCorp: 4,
  RACQ: 5
}
